import SponsorService from '../services/SponsorService'
import { useSponsorContext } from '../context/sponsor/SponsorProvider'
import { SPONSOR_ACTIONS } from '../context/sponsor/SPONSOR_ACTIONS'
import { useSponsorTypesContext } from '../context/sponsor-types/SponsorTypeProvider'
import { SPONSOR_TYPES_ACTIONS } from '../context/sponsor-types/SPONSOR_TYPES_ACTIONS'
import { useNavigate, useParams } from 'react-router'

export default function useSponsorsActions() {
  const navigate = useNavigate()
  const { lng } = useParams()
  const { sponsorTypesDispatch } = useSponsorTypesContext()
  const { sponsorDispatch } = useSponsorContext()

  async function getSponsorTypes() {
    try {
      sponsorTypesDispatch({
        type: SPONSOR_TYPES_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await SponsorService.getSponsorTypes()

      sponsorTypesDispatch({
        type: SPONSOR_TYPES_ACTIONS.SET_SPONSOR_TYPES,
        payload: {
          types: data.types,
        },
      })
    } catch (error) {
      console.log(error)
    } finally {
      sponsorTypesDispatch({
        type: SPONSOR_TYPES_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  async function getSponsor(sponsorSlug) {
    try {
      sponsorDispatch({
        type: SPONSOR_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await SponsorService.getSponsor(sponsorSlug)

      sponsorDispatch({
        type: SPONSOR_ACTIONS.SET_SPONSOR,
        payload: {
          sponsor: data.sponsor,
        },
      })
      return data.sponsor
    } catch (error) {
      console.log(error)
      // Redirect if the sponsor is not found or the request failed
      navigate(`/${lng}/not-found`, { replace: true })
      return
    } finally {
      sponsorDispatch({
        type: SPONSOR_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  return { getSponsorTypes, getSponsor }
}
